import { useCallback, useMemo, useState } from "react";

import * as ModelConverter from "@/components/features/_model/converter";

import * as Factory from "./factory";
import * as FormModelType from "./type";
import * as ValidationSchema from "./validation-schema";

export const usePaymentCreditFormModel = (initInputModel: FormModelType.PaymentCreditFormModel["InputModel"]) => {
	const defaultInputModel = useMemo(
		() => Factory.Default.paymentCreditInputModelFactory(initInputModel.hotelID),
		[initInputModel.hotelID],
	);

	// InputModel の初期化
	const [currentInputModel, setCurrentInputModel] =
		useState<FormModelType.PaymentCreditFormModel["InputModel"]>(initInputModel);

	// ViewModel の初期化
	const [viewModel, setViewModel] = useState<FormModelType.PaymentCreditFormModel["ViewModel"]>(
		ModelConverter.inputModelToViewModelConverter<
			FormModelType.PaymentCreditFormModel["InputModel"],
			FormModelType.ExcludeKeys,
			FormModelType.PaymentCreditFormModel["QueryData"],
			ValidationSchema.PaymentCreditInputZodSchemaType
		>({
			defaultInput: defaultInputModel,
			initInput: initInputModel,
			currentInput: initInputModel,
			excludeKeys: FormModelType.excludeKeys,
			zodSchema: ValidationSchema.PaymentCreditInputZodSchema,
		}),
	);

	// ViewModel の更新
	const onSetViewModel = useCallback((_viewModel: FormModelType.PaymentCreditFormModel["ViewModel"]) => {
		// UI で変更された、_viewModel を InputModel に変換
		const convertedInputModel = ModelConverter.viewModelToInputModelConverter(_viewModel);
		// state の更新
		setCurrentInputModel(convertedInputModel);
		setViewModel(_viewModel);
	}, []);

	return {
		inputModel: currentInputModel,
		viewModel,
		onSetViewModel,
	};
};
